// extracted by mini-css-extract-plugin
module.exports = {"table":"JobDetailsDrawer_table__3Sobe","errorCode":"JobDetailsDrawer_errorCode__2sdnb"};